module.exports = __webpack_public_path__ + "img/Mardona-7.7da3daf3.webp";